export const whichProviderData = {
  title: 'Who is your broadband provider?',
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/5e64c8f9579d-tooliconquestion.jpg',
  },
}
